import ReactSelect from 'react-select';
import { withAnalyticsEvents, withAnalyticsContext, createAndFireEvent } from '@atlaskit/analytics-next';
import createSelect from './createSelect';
const packageName = "@atlaskit/select";
const packageVersion = "17.19.3";
export const SelectWithoutAnalytics = createSelect(ReactSelect);
const createAndFireEventOnAtlaskit = createAndFireEvent('atlaskit');
const Select = withAnalyticsContext({
  componentName: 'select',
  packageName,
  packageVersion
})(withAnalyticsEvents({
  onChange: createAndFireEventOnAtlaskit({
    action: 'changed',
    actionSubject: 'option',
    attributes: {
      componentName: 'select',
      packageName,
      packageVersion
    }
  })
})(SelectWithoutAnalytics));
export default Select;